import React from "react";
import { Mail, Shield } from "lucide-react";
import Logo from "@/library/components/Logo";
import CreditBar from "@/library/components/CreditBar";
import { useSettings } from "@/library/lib/settings";

const Footer = () => {
  const s = useSettings();
  return (
    <footer data-testid="footer" className="mt-16 bg-brand-dark text-white/90">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-3 gap-8">
        <div>
          <div className="bg-white/5 rounded-xl p-3 mb-3 inline-block">
            <Logo size={44} showText={false} />
          </div>
          <div className="font-heading font-extrabold text-lg mb-2">{s.site_name} — {s.school_name}</div>
          <p className="text-sm text-white/70 leading-relaxed">{s.footer_about}</p>
        </div>
        <div>
          <div className="font-heading font-bold mb-3 text-gold-light">روابط سريعة</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/library" className="hover:text-gold-light">الصفحة الرئيسية</a></li>
            <li><a href="/library/levels" className="hover:text-gold-light">المراحل الدراسية</a></li>
            <li><a href="/library/admin/login" className="hover:text-gold-light">لوحة الإدارة</a></li>
          </ul>
        </div>
        <div>
          <div className="font-heading font-bold mb-3 text-gold-light">المؤسسة</div>
          <div className="text-sm space-y-2 text-white/70">
            <div className="flex items-center gap-2"><Shield className="w-4 h-4 text-gold" /> {s.school_name}</div>
            {s.contact_email && <div className="flex items-center gap-2"><Mail className="w-4 h-4 text-gold" /> {s.contact_email}</div>}
          </div>
        </div>
      </div>
      <CreditBar />
      <div className="border-t border-white/10 py-4 text-center text-xs text-white/50">
        © {new Date().getFullYear()} {s.site_name} — {s.school_name}. جميع الحقوق محفوظة.
      </div>
    </footer>
  );
};

export default Footer;
